import { call, put, takeEvery, select } from "redux-saga/effects"
import axios from "axios"
import axiosClient from "../../../helpers/axiosClient"

// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  FETCH_EMPRESAS,
  SET_EMPRESA_SELECCIONADA,
} from "./actionTypes"
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  fetchEmpresasSuccess,
  fetchEmpresasError,
} from "./actions"

const baseURL = process.env.REACT_APP_API_URL

// Decode JWT payload to extract user claims (esSuperAdmin, etc.)
function decodeJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64).split('').map(c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join('')
    )
    return JSON.parse(jsonPayload)
  } catch {
    return {}
  }
}

function* loginUser({ payload: { user, history } }) {
  try {
    // Usar axios directo para el login (no hay token aún)
    const response = yield call(axios.post, `${baseURL}auth/login`, {
      email: user.email,
      password: user.password,
    })

    const { accessToken, refreshToken, usuario } = response.data.data

    // Extract esSuperAdmin from JWT payload and merge into usuario
    const tokenPayload = decodeJwtPayload(accessToken)
    const enrichedUsuario = {
      ...usuario,
      esSuperAdmin: tokenPayload.esSuperAdmin === true || tokenPayload.superAdmin === true || false,
    }

    const authData = { accessToken, refreshToken, usuario: enrichedUsuario }
    localStorage.setItem("authUser", JSON.stringify(authData))

    yield put(loginSuccess(authData))
    history("/seleccionar-empresa")
  } catch (error) {
    const message =
      error.response?.data?.message || "Error al iniciar sesión"
    yield put(apiError(message))
  }
}

function* fetchEmpresas() {
  try {
    // SuperAdmin ve todas las empresas, usuario normal solo las suyas
    const user = yield select(state => state.Login.user)
    const endpoint = user?.esSuperAdmin ? "empresas" : "empresas/mis-empresas"
    const response = yield call([axiosClient, "get"], endpoint)
    const empresas = response.data.data
    yield put(fetchEmpresasSuccess(empresas))
  } catch (error) {
    const message =
      error.response?.data?.message || "Error al obtener empresas"
    yield put(fetchEmpresasError(message))
  }
}

function* selectEmpresa({ payload: { empresa, history } }) {
  localStorage.setItem("empresaSeleccionada", JSON.stringify(empresa))
  // Redux dispatch via SET_EMPRESA_SELECCIONADA already updates state
  // No navigation needed - stay on current page
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("empresaSeleccionada")
    history("/login")
    yield put(logoutUserSuccess())
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(FETCH_EMPRESAS, fetchEmpresas)
  yield takeEvery(SET_EMPRESA_SELECCIONADA, selectEmpresa)
}

export default authSaga
